import React, { useCallback, useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { 
  Character,
  // CharacterFeatureSource,
  CharacterSheetInterface,
  Modifier,
} from "@dndModels";
import { 
  SPEED_OPTIONS 
} from "@dndModels/Constants";

import FloatMenu from "@components/input/menus/FloatMenu";
import CharacterFeatureFromSource from "@dndComponents/character/features/CharacterFeatureFromSource";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import { IStringHash } from "@models";
import CharacterSpeedCustomizations from '../customizations/CharacterSpeedCustomizations';

interface Props {
  char: Character;
  char_interface: CharacterSheetInterface;
  disabled: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterSpeedsButton({ 
  char,
  char_interface,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [view, setView] = useState("Features");
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setReloading(true);
  }, [char]);

  useEffect(() => {
    char.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    recalculated();
  }, [char, recalculated]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderSpeedFeatures = () => {
    const speed_features = char.mind.modifier_features.filter(cf => 
      cf.floating_feature instanceof Modifier && 
        ["Speed"].includes(cf.floating_feature.modifies));
    return (
      <>
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          Speed Features
        </Grid>
        { speed_features.sort((a,b) => { return a.name.localeCompare(b.name) }).map((char_feature, key) => {
          const source = char.char_feature_sources.find(o => 
            o.true_id === char_feature.source_true_id);
          if (source) {
            return (
              <Grid
                key={key}
                size={{
                  xs: 12
                }}>
                <CharacterFeatureFromSource
                  char={char}
                  obj={char_feature}
                  source={source}
                />
              </Grid>
            );
          }
          return null;
        })}
      </>
    );
  }

  const renderSpeedCustomizations = () => {
    return (
      <Grid size={12}>
        <CharacterSpeedCustomizations char={char} />
      </Grid>
    );
  }

  const renderView = () => {
    switch(view) {
      // case "Current": return renderCurrent();
      case "Features": return renderSpeedFeatures();
      // case "Bonus Proficiencies": return renderBonusSpeedProfs();
      default: return renderSpeedCustomizations();
    }
  }

  const options = ["Features","Extra Modifiers","Override Speeds"];
  const SPEED_map: IStringHash = {};
  const any_speeds = char_interface.mind.speed as any;
  for (const o of SPEED_OPTIONS) {
    SPEED_map[o.id] = `${o.text} ${any_speeds[o.id]} ft.`;
  }
  // console.log(SPEED_map);
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className="centered header"
        size={{
          xs: 12
        }}>
        Manage Speeds
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox
          name="Display Speed"
          options={SPEED_OPTIONS.map(o => o.id)}
          display_map={SPEED_map}
          value={char_interface.mind.display_speed}
          onChange={(changed: "walk" | "swim" | "climb" | "fly" | "burrow") => {
            char_interface.mind.display_speed = changed;
            // character.changed();
            // console.log("Display Speed Change");
            // console.log(character);
            char.subscription_holder.displayChanged();
            setReloading(true);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <FloatMenu
          options={options}
          selected={view}
          onSelect={setView}
        />
      </Grid>
      { renderView() }
    </Grid>
  );
}
